import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Loader from '../../../components/base/Loader/Loader';
import { loadPreviewDocument } from '../actions';
import { errorNotification } from '../../Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';
import { getAwaitDocumentData } from '../reducer';

export default function PreviewDocument(props) {
  const {
    type = '',
    currentApplication = null,
    callbackValue = null,
    handleClose = () => {},
    handleCallback = () => {},
  } = props;
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const { loadingPreviewDocument } = useSelector(getAwaitDocumentData);
  useEffect(() => {
    const data = { type, context: callbackValue, application_id: currentApplication.id };
    dispatch(loadPreviewDocument(data))
      .then(f => setFile(URL.createObjectURL(f)))
      .catch(response => errorNotification('Загрузка документа', getResponseError(response)));
  }, []);

  return (
    <Dialog
      onClose={handleClose}
      open
      className={classNames('file-viewer')}
      size="xl"
    >
      <DialogTitle
        header={(
          <div className="file-viewer-header">
            <div className="application-form-header">
              <div className="breadcrumbs">
                <span className="breadcrumbs-current">
                  Просмотр документа
                </span>
              </div>
            </div>
          </div>
        )}
        title={<Icons onClick={handleClose} customIcon icon="close" className="close" />}
      />
      <DialogContent>
        <Loader loading={loadingPreviewDocument} />
        {!loadingPreviewDocument && file ? <iframe title="Просмотр файла" src={file} frameBorder="0" width="100%" height="100%" /> : null}
        {!loadingPreviewDocument && !file ? <div className="file-not-found">Файл не найден</div> : null}
        {loadingPreviewDocument && (<div className="file-not-found">Идет загрузка данных...</div>)}
      </DialogContent>
      <DialogFooter className="modal-buttons">
        <div className="ms-auto" />
        <Button variant="secondary" onClick={handleClose}>Отмена</Button>
        <Button onClick={handleCallback}>Принять</Button>
      </DialogFooter>
    </Dialog>
  );
}
